// extracted by mini-css-extract-plugin
module.exports = {"todoContainer":"styles_todoContainer__3-qVZ","todo":"styles_todo__3TbZx","leftTodo":"styles_leftTodo__PZgMY","notActive":"styles_notActive__2xn8f"};